import { NpvrEventItem } from '@smart-tv/typings/npvr';

import { kmm } from './kmm';
import { mapNpvrEvent } from './npvr-helpers';

export async function getFailedNpvrEvents(): Promise<NpvrEventItem[]> {
  const events = await kmm((repo) => repo.getFailedNpvrEvents());

  return events.asJsReadonlyArrayView().map(mapNpvrEvent);
}

export default getFailedNpvrEvents;
